import type { ReactNode } from "react";

/** Repository content uses plain text or JSX, independent of a CMS format. */
export default function TextContent({ children }: { children?: ReactNode }) {
  return typeof children === "string" ? <p>{children}</p> : children;
}
